<template>
    <div class="main">
      <div class="head">
        <h1 style="margin:0;font-weight:500;">주문/배송</h1>
        <hr>
      </div>
      <div class="body"  v-if="!$empty(data)">
        <div class="link-app-div">
          <div class="left">
            <img src="@/assets/icon/tery-left.png" class="tery-left" alt="">
          </div>
          <div class="right">
            <div class="right-top">
              <span class="detail-app-span">더 자세한 내용은 테리앱에서</span>
            </div>
            <div class="right-bot">
              <button class="link-app-btn">
                <a :href="appLink">
                  <img src="@/assets/btn_playstore.png" class="link-app-btn-img">
                </a>
              </button>
            </div>
          </div>
        </div>
        <div class="orderHistory" v-for="(row, index) in data" :key="index">
            <div class="orderHistory-top">
              <h3 style="margin:0;">
                {{row.storeName}}
              </h3>
            </div>
            <div class="orderHistory-body">
              <div>
                <span class="orderInfo-title">
                  주문번호:
                </span>
                <span class="orderInfo-content">
                  {{row.orderNo}}
                </span>
              </div>
              <div>
                <span class="orderInfo-title">
                  주문일시:
                </span>
                <span class="orderInfo-content">{{$dayjs(row.orderDate).format('YYYY-MM-DD HH:mm:ss')}}</span>
              </div>
              <div>
                <span class="orderInfo-title">
                  결제금액:
                </span>
                <span class="totalValue" style="margin:0;font-size: 1.4rem;">
                  {{numberWithCommas(row.orderPrice)}}
                </span>
              </div>
              <div class="orderHistory-foot">
                <div class="foot-inner-div" v-if="row.orderState === 1">
                  <button class="orderFuncBtn-cancel" @click="preOrderCancel(row)">주문취소</button>
                </div>
                <div class="foot-inner-div">
                  <button class="orderFuncBtn-detail" @click="getOrderDetail(row.detailInfo, row.deliveryInfo, row.deliveryPrice)">주문상세</button>
                </div>
              </div>
              <div style="width: 100%;">
                <vue-step v-if="row.orderState !== 9"
                :now-step="Number(row.orderState) || 1"
                :step-list="stepList"
                active-color="#ea4e83" style="width: 100%;"></vue-step>
                <vue-step v-else
                :now-step="Number(cancelStep) || 1"
                :step-list="cancelList"
                active-color="#828282" style=""></vue-step>
              </div>
            </div>
        </div>
        <!-- <div class="orderHistory" v-for="(row, index) in data" :key="index">
          <div class="orderHistoryLeft">
            <div>
              <div>
                <span style="font-size: 13px;color:#a0a0a0;margin:auto;">
                  주문번호:
                </span>
                <span>
                  {{row.orderNo}}
                </span>
              </div>
            </div>
            <div>
              <span style="font-size: 13px;color:#a0a0a0;margin:auto;">
                주문일시:
              </span>
              <span>{{$dayjs(row.orderDate).format('YYYY-MM-DD HH:mm:ss')}}</span>
            </div>
            <div>
              <h3 style="margin:0;">
                {{row.storeName}}
              </h3>
            </div>
            <div>
              <span>주문상태</span>
              <vue-step v-if="row.orderState !== 9"
              :now-step="row.orderState"
              :step-list="stepList"
              active-color="#ea4e83" style=""></vue-step>
              <vue-step v-else
              :now-step="cancelStep"
              :step-list="cancelList"
              active-color="#828282" style=""></vue-step>
            </div>
          </div>
          <div class="orderHistoryRight">
            <div class="orderHistoryRight-detail" style="height: 20%;">
              <button class="orderFuncBtn" v-if="row.orderState === 1" @click="preOrderCancel(row)">주문취소</button>
            </div>
            <div class="orderHistoryRight-detail" style="height: 20%;">
              <button class="orderFuncBtn" @click="getOrderDetail(row.detailInfo, row.deliveryInfo)">주문상세</button>
            </div>
            <div class="orderHistoryRight-detail" style="height: 20%;">
            </div>
            <div class="orderHistoryRight-detail" style="height: 40%;">
              <span style="font-size: 13px;color:#a0a0a0;margin:auto;">결제금액</span>&emsp;
              <h3 style="margin:0;">
                {{numberWithCommas(row.orderPrice)}}
              </h3>
            </div>
          </div>
        </div> -->
      </div>
      <div class="body" v-else-if="$empty(data)">
        <div class="link-app-div">
          <div class="left">
            <img src="@/assets/icon/tery-left.png" class="tery-left" alt="">
          </div>
          <div class="right">
            <div class="right-top">
              <span class="detail-app-span">더 자세한 내용은 테리앱에서</span>
            </div>
            <div class="right-bot">
              <button class="link-app-btn">
                <a :href="appLink">
                  <img src="@/assets/btn_playstore.png" class="link-app-btn-img">
                </a>
              </button>
            </div>
          </div>
        </div>
        <!-- <h3>주문/배송 내역이 없습니다.</h3> -->
        <!-- <img src="@/assets/no_product.png" class="no-product-img"> -->
        <div class="no-orderList-div">
          <div class="no-orderList-img-div">
            <img class="crying-img" src="@/assets/tery_empty.png" alt="">
            <h2>
              주문 내역이 없습니다.
            </h2>
            <!-- <div class="left">
              <img class="crying-img" src="@/assets/tery_crying.png" alt="">
            </div>
            <div class="right">
              <div class="top-div">
                <span class="no-order-span">
                  주문 상품이
                </span>
              </div>
              <div class="bottom">
                <span class="no-order-span" style="color:#636363;">
                  &emsp;없습니다.
                </span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import * as mutations from '@/graphql/mutations'
import * as queries from '@/graphql/queries'
import { API, graphqlOperation } from 'aws-amplify'
import { components } from 'aws-amplify-vue'
import vueStep from 'vue-step'
import { loginWithKakao } from '@/components/publicFunc/public'
export default {
  name: 'orderProcessList',
  components: {
    components,
    vueStep
  },
  data () {
    return {
      data: [],
      endDay: this.$dayjs().daysInMonth(),
      stepList: ['주문접수', '배송준비', '배송중', '배송완료'],
      cancelList: ['주문취소'],
      cancelStep: 1,
      nowStep: 1,
      userData: {},
      appLink: 'Intent://event?storeSeq=' + this.$route.query.seq + '#Intent;scheme=tonolink;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.tonovation.tery;end',
      scrollY: 0,
      nextToken: null
    }
  },
  computed: {
    key: {
      get () {
        return this.$store.state.key
      },
      set (key) {
        return key
      }
    }
  },
  watch: {
    key () {
      this.data = []
      this.getOrderHistory()
    }
  },
  created () {
    this.userData = this.$cookies.get('userData')
  },
  mounted () {
    console.log('mounted::', this.$options.name)
    this.$cookies.set('nowPage', 'orderProcessList')
    this.$store.state.isLoading = true
    if (!this.$empty(this.key)) {
      this.data = []
      this.getOrderHistory()
    }
    // window.onpopstate = event => {
    //   alert('location: ' + document.location + ', state: ' + JSON.stringify(event.state))
    //   if (document.location.indexOf(location.host) === -1) {
    //     this.moveRouter('storeMain')
    //   }
    // }
    // if (!this.$empty(this.$cookies.get('kakaoLogin'))) {
    // } else {
    //   console.log('22222')
    //   this.$store.state.isLoading = true
    //   this.loginWithKakao1()
    // }
  },
  methods: {
    loginWithKakao1 () {
      loginWithKakao()
    },
    async getOrderHistory () {
      const vm = this
      console.log('getOrderHistory :::::')
      const tmp = await API.graphql(
        graphqlOperation(queries.querySeryOrderInfosByUserSeqStoreSeq2, {
          storeSeq: vm.$route.query.seq,
          userSeq: !vm.$empty(Number(vm.userData)) ? Number(vm.userData.USER_SEQ) : Number(vm.$cookies.get('userSeq')),
          startDate: vm.$dayjs().format(`YYYY-MM-01T00:00:00.000Z`),
          endDate: vm.$dayjs().format(`YYYY-MM-${vm.endDay}T23:59:59.999Z`),
          searchType: 4,
          nextToken: !vm.$empty(vm.nextToken) ? vm.nextToken : ''
        })
      )

      if (!vm.$empty(tmp.data.querySeryOrderInfosByUserSeqStoreSeq2.nextToken)) {
        vm.nextToken = tmp.data.querySeryOrderInfosByUserSeqStoreSeq2.nextToken
        for await (const item of tmp.data.querySeryOrderInfosByUserSeqStoreSeq2.items) {
          vm.data.push(item)
        }
        try {
          return await vm.getOrderHistory()
        } catch (error) {
          console.log('getOrderHistory :::::', error)
        }
      } else {
        for await (const item of tmp.data.querySeryOrderInfosByUserSeqStoreSeq2.items) {
          vm.data.push(item)
        }
      }
      // var item = tmp.data.querySeryOrderInfosByUserSeqStoreSeq.items
      vm.data = vm.$_.cloneDeep(vm.$_.sortBy(vm.data, 'orderDate').reverse())
      vm.$store.state.isLoading = false
    },
    async getOrderDetail (data, address, deliveryPrice) {
      var dataArr = {
        deliveryInfo: {},
        data: [],
        deliveryPrice: deliveryPrice
      }
      for (let i = 0; i < data.length; i++) {
        var tmp = JSON.parse(data[i])
        dataArr.deliveryInfo = JSON.parse(address)
        dataArr.data.push(tmp)
        if (i === data.length - 1) {
          this.$store.state.orderDetail = this.$_.cloneDeep(dataArr)
          this.$modal.show('orderDetail')
        }
      }
    },
    async preOrderCancel (row) {
      const vm = this
      const tmp1 = await API.graphql(
        graphqlOperation(queries.getSeryOrderInfo, {
          orderSeq: row.orderSeq
        })
      )
      console.log('orderDate :::::', tmp1.data.getSeryOrderInfo)
      switch (tmp1.data.getSeryOrderInfo.orderState) {
        case 1:
          if (confirm('상품이 준비중입니다.\n정말 취소하시겠습니까?')) {
            this.$store.state.isLoading = true
            console.log(row)
            var updateObj = {
              orderSeq: row.orderSeq,
              storeSeq: row.storeSeq,
              userSeq: row.userSeq,
              deliveryInfo: row.deliveryInfo,
              orderDate: row.orderDate,
              paymentType: row.paymentType,
              deliveryType: row.deliveryType,
              memo: row.memo,
              orderNo: row.orderNo,
              orderPrice: row.orderPrice,
              deliveryPrice: row.deliveryPrice,
              orderState: 9,
              deliveryName: row.deliveryName,
              deliveryCode: row.deliveryCode,
              deliveryNo: row.deliveryNo,
              receiveCode: row.receiveCode,
              bookingTime: row.bookingTime,
              detailInfo: row.detailInfo,
              deliveryTime: row.deliveryTime,
              doneTime: this.$dayjs().format(`YYYY-MM-DDTHH:mm:ss.SSSZ`),
              riderId: row.riderId,
              cancelReason: '구매의사취소',
              cancelReasonDetail: '고객 직접 취소'
            }
            if (row.paymentType === 1 || row.paymentType === 8) {
              this.$axios({
                method: 'post',
                headers: {
                  'content-type': 'application/json'
                },
                url: 'https://sery.co.kr/payment2CardCancelReturn',
                // url: 'http://192.168.0.2:9090/payment2CardCancelReturn',
                data: {
                  mchtId: 'tono2',
                  ver: '0A17',
                  method: 'CA',
                  bizType: 'C0',
                  encCd: '23',
                  mchtTrdNo: row.orderSeq,
                  trdDt: this.$dayjs().format('YYYYMMDD'),
                  trdTm: this.$dayjs().format('HHmmss'),
                  mobileYn: 'N',
                  osType: 'W',
                  orderSeq: row.orderSeq

                }
              }).then(async (response) => {
                console.log('카드취소:::', response.data)
                if (!vm.$empty(response.data) && response.data.result === 'success') {
                  var update = await API.graphql(graphqlOperation(
                    mutations.updateSeryOrderInfo, {
                      input: updateObj
                    })
                  )
                  console.log('update:::', update)
                  sendPush()
                  vm.data = []
                  vm.getOrderHistory()
                } else {
                  alert('정상적으로 취소가 진행되지 않았습니다.\n고객센터 1661-9068로 연락바랍니다.')
                }
              }).catch(err => {
                console.log('카드취소:::', err)
                this.$store.state.isLoading = false
              })
            } else {
              var update = await API.graphql(graphqlOperation(
                mutations.updateSeryOrderInfo, {
                  input: updateObj
                })
              )
              console.log('update:::', update)
              sendPush()
              vm.data = []
              vm.getOrderHistory()
            }
          }
          break
        case 2:
        case 3:
        case 4:
          if (confirm('상품이 배송 중 입니다.\n매장과 통화 후 처리하시겠습니까?')) {
            document.location.href = 'tel:' + this.$store.state.storeTel
          }
          break
      }
      function sendPush () {
        vm.$axios({
          method: 'post',
          url: 'https://www.sery.co.kr/store/v4/' + vm.$route.query.seq + '/orders',
          data: {
            deliveryInfo: {
              failCode: '',
              result: ''
            },
            failCode: '',
            memo: `접수된 주문이 취소되었습니다.|- 주문번호 : ${updateObj.orderNo}|- 주문일시 : ${vm.$dayjs(updateObj.orderDate).format('YYYY-MM-DD HH:mm:ss')}|- 취소일시 : ${vm.$dayjs(updateObj.doneTime).format('YYYY-MM-DD HH:mm:ss')}|- 주문금액 : ${vm.numberWithCommas(updateObj.orderPrice)}`,
            orderDetails: [],
            orderNo: updateObj.orderNo,
            result: '',
            storeInfo: {
              endPuter: 10,
              failCode: '',
              heloFriendCount: 0,
              result: '',
              staffCount: 0,
              startPuter: 0,
              storeDelivery: {
                deliveryCost: 0,
                minPromoCost: 0
              }
            },
            storeSeq: vm.$route.query.seq
          }
        })
      }
    },
    numberWithCommas (x) {
      if (!x) {
        return '0원'
      } else if (x === 0 || x === '0') {
        return ''
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원'
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      console.log('beforeRouteEnter :::::', vm.scrollY, document.querySelector('.main'))
      if (document.querySelector('html') !== null) {
        setTimeout(() => {
          document.querySelector('html').scrollTop = vm.scrollY
        }, 100)
      } else {
        setTimeout(() => {
          document.querySelector('html').scrollTop = vm.scrollY
        }, 1000)
      }
    })
  },
  // Record where you left
  beforeRouteLeave (to, from, next) {
    this.scrollY = document.querySelector('html').scrollTop
    console.log('Where to save the scroll bar when leaving', this.scrollY)
    next()
  }
}
</script>

<style scoped>
@import url('/css/orderProcessList.css');
</style>



// WEBPACK FOOTER //
// src/components/orderProcessList/orderProcessList.vue